"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _core.makeStyles)(function () {
  return {
    iconDropdown: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  };
});
function FeatureIconSelector(_ref) {
  var selectedIcon = _ref.selectedIcon,
    setSelectedIcon = _ref.setSelectedIcon;
  var classes = useStyles();
  var requireIcons = require.context("../../../assets/feature-icons", false, /\.svg$/);
  var icons = requireIcons.keys().map(function (fileName) {
    return {
      name: fileName.replace("./", "").replace(".svg", ""),
      path: requireIcons(fileName)["default"]
    };
  });
  var handleChange = function handleChange(event) {
    var selectedName = event.target.value;
    setSelectedIcon(selectedName);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    fullWidth: true,
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    id: "icon-dropdown-label"
  }, "Select Icon"), /*#__PURE__*/_react["default"].createElement(_core.Select, {
    labelId: "icon-dropdown-label",
    value: selectedIcon,
    onChange: handleChange
  }, icons.map(function (icon) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: icon.name,
      value: icon.name
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.iconDropdown
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: icon.path,
      alt: icon.name,
      width: "24",
      height: "24"
    }), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      primary: icon.name
    })));
  })));
}
var _default = exports["default"] = FeatureIconSelector;